import { styled } from '@mui/material';
import { FormTextField } from 'common/components/input';

export const TitleInput = styled(FormTextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root > textarea': {
    fontSize: theme.typography.h3.fontSize,
    fontWeight: 600,
  },
}));
